module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_5-1d80ce56f130dbf40f2e1aba2893d4ce.jpg";